import type { IAssignmentRepository } from '@/core/domain/school/assignment/IAssignmentRepository'
import type { Assignment } from '@/core/domain/school/assignment/Assignment'
import type { AssignmentInputEntity } from '@/core/infrastructure/schemas/school/assignment/AssignmentSchema'

/**
 * Use case pour créer un nouvel assignment
 */
export class CreateAssignmentUseCase {
  private assignmentRepository: IAssignmentRepository

  constructor(assignmentRepository: IAssignmentRepository) {
    this.assignmentRepository = assignmentRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    assignment: AssignmentInputEntity
  ): Promise<Assignment> {
    return await this.assignmentRepository.createAssignment(schoolId, periodId, assignment)
  }
}
